import * as React from "react"

import { cn } from "../../lib/utils"

export interface InputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
              className={cn(
        "flex w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm outline-none ring-2 ring-transparent transition focus:border-gray-400 focus:ring-gray-200 disabled:cursor-not-allowed disabled:bg-gray-100 hover:border-gray-400",
        className
      )}
        ref={ref}
        {...props}
      />
    )
  }
)
Input.displayName = "Input"

export { Input }
